import React, { Component } from 'react';
import { Marker, Polyline } from 'react-google-maps';
import MapaGoogle from '../mapa/mapaGoogle';

// Distância entre dois pontos (metros) via fórmula de haversine.
function distanciaHaversine(a, b) {
  const R = 6371000;
  const rad = deg => (deg * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const lat1 = rad(a.lat);
  const lat2 = rad(b.lat);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

function comprimentoTotal(pontos) {
  let total = 0;
  for (let i = 1; i < pontos.length; i++) {
    total += distanciaHaversine(pontos[i - 1], pontos[i]);
  }
  return total;
}

const numeroIcon = numero => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
    <circle cx="13" cy="13" r="11" fill="#1976d2" stroke="#ffffff" stroke-width="2"/>
    <text x="13" y="17" font-size="12" font-family="Arial" font-weight="bold" fill="#ffffff" text-anchor="middle">${numero}</text>
  </svg>`;
  const url = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
  if (typeof window !== 'undefined' && window.google && window.google.maps) {
    return {
      url,
      scaledSize: new window.google.maps.Size(26, 26),
      anchor: new window.google.maps.Point(13, 13),
    };
  }
  return { url };
};

class MedirTrechoMapa extends Component {
  constructor(props) {
    super(props);
    const lat = Number(props.latitude);
    const lng = Number(props.longitude);
    const inicial = Number.isFinite(lat) && Number.isFinite(lng) && (lat !== 0 || lng !== 0) ? [{ lat, lng }] : [];
    this.state = { pontos: inicial };
    this.handleMapClick = this.handleMapClick.bind(this);
    this.desfazer = this.desfazer.bind(this);
    this.limpar = this.limpar.bind(this);
    this.confirmar = this.confirmar.bind(this);
  }

  handleMapClick(e) {
    if (!e || !e.latLng) return;
    const ponto = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    this.setState(state => ({ pontos: [...state.pontos, ponto] }));
  }

  desfazer() {
    this.setState(state => ({ pontos: state.pontos.slice(0, -1) }));
  }

  limpar() {
    this.setState({ pontos: [] });
  }

  confirmar() {
    const metros = Math.round(comprimentoTotal(this.state.pontos));
    if (this.props.onConfirmar) this.props.onConfirmar(metros);
  }

  render() {
    const { pontos } = this.state;
    const metros = Math.round(comprimentoTotal(pontos));
    const lat = Number(this.props.latitude);
    const lng = Number(this.props.longitude);
    const center =
      Number.isFinite(lat) && Number.isFinite(lng) && (lat !== 0 || lng !== 0)
        ? { lat, lng }
        : { lat: -23.55, lng: -46.63 };

    return (
      <div>
        <div className="medir-trecho__toolbar">
          <span className="medir-trecho__hint">
            <i className="fa fa-info-circle" /> Clique no mapa ao longo da via para marcar o trecho. O 1º ponto já está
            no pin da fase.
          </span>
          <span className="medir-trecho__total">{metros} m</span>
        </div>

        <MapaGoogle
          containerElement={<div style={{ height: '55vh', width: '100%' }} />}
          mapElement={<div style={{ height: '100%' }} />}
          defaultCenter={center}
          defaultZoom={19}
          options={{ mapTypeId: 'hybrid', mapTypeControl: true, streetViewControl: false }}
          onClick={this.handleMapClick}
        >
          {pontos.length > 1 && (
            <Polyline
              path={pontos}
              options={{ strokeColor: '#1976d2', strokeOpacity: 0.9, strokeWeight: 5 }}
            />
          )}
          {pontos.map((p, i) => (
            <Marker key={i} position={p} icon={numeroIcon(i + 1)} />
          ))}
        </MapaGoogle>

        <div className="medir-trecho__actions">
          <div className="medir-trecho__actions-left">
            <button type="button" className="btn btn-default btn-sm" onClick={this.desfazer} disabled={!pontos.length}>
              <i className="fa fa-undo" /> Desfazer
            </button>
            <button type="button" className="btn btn-default btn-sm" onClick={this.limpar} disabled={!pontos.length}>
              <i className="fa fa-trash" /> Limpar
            </button>
          </div>
          <div className="medir-trecho__actions-right">
            <button type="button" className="btn btn-default btn-sm" onClick={this.props.onCancelar}>
              <i className="fa fa-times" /> Cancelar
            </button>
            <button type="button" className="btn btn-primary btn-sm" onClick={this.confirmar} disabled={pontos.length < 2}>
              <i className="fa fa-check" /> Usar medição ({metros} m)
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default MedirTrechoMapa;
